import React from 'react'
import { Provider } from 'react-redux'
import RootContainer from 'apa/containers/RootContainer'
import store from 'apa/Storage'
import AlertList from 'apa/containers/AlertList';

const App = () => (
  <Provider store={store}>
    <RootContainer />
    <AlertList />
  </Provider>
)

export default App
